import { createSelector } from 'reselect'

import { StatisticsRootState } from '../statisticsRoot.reducer'

export const getFacebookPageStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsUserStore.facebookPageStatistics,
  (state) => state,
)
export const getInstagramPageStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsUserStore.instagramPageStatistics,
  (state) => state,
)
